import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getTyreSeasonParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'tyreSeasonParts';

export const tyreSeasonPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearTyreSeasonParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getTyreSeasonParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearTyreSeasonParts } = tyreSeasonPartsSlice.actions;

export const tyreSeasonParts = tyreSeasonPartsSlice.reducer;
